/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from 'static/images/close.svg';
import styles from './AppNotification.css';

function AppNotification(props) {
  const { apiServiceError } = props;
  const [status, setStatus] = React.useState({});
  const StatusUrls = () => {
    return (
      <ul>
        {status[apiServiceError.status].map((url, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`statusUrlsKey_${url}_${i}`}>{url}</li>
        ))}
      </ul>
    );
  };
  const Msg = () => {
    return (
      <div className={styles.container}>
        <h4 className={styles.title}>
          Error {apiServiceError.status}: Service Unavailable
        </h4>
        <div className={styles.message}>
          The following data services are not responding:
          <StatusUrls />
        </div>
      </div>
    );
  };
  const CloseButton = ({ closeToast }) => (
    <button
      className="Toastify__close-button Toastify__close-button--default"
      type="button"
      onClick={() => {
        setStatus({
          [apiServiceError.status]: null,
        });
        closeToast();
      }}
    >
      <CloseIcon />
    </button>
  );
  const ClickHandler = () => {
    setStatus({
      [apiServiceError.status]: null,
    });
  };

  React.useEffect(() => {
    if (apiServiceError && apiServiceError.status) {
      if (status[apiServiceError.status]) {
        status[apiServiceError.status].push(apiServiceError.url);
      } else {
        setStatus({
          [apiServiceError.status]: [apiServiceError.url],
        });
      }
    }
  }, [apiServiceError]);
  React.useEffect(() => {
    if (apiServiceError && status[apiServiceError.status]) {
      const len = status[apiServiceError.status].length;
      if (len === 1) {
        toast(<Msg />, {
          toastId: apiServiceError.status,
        });
      } else {
        toast.update(apiServiceError.status, {
          render: <Msg />,
        });
      }
    }
  }, [status, apiServiceError]);

  return (
    <ToastContainer
      position="top-center"
      autoClose={false}
      hideProgressBar
      newestOnTop
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      closeButton={CloseButton}
      closeOnClick
      onClick={ClickHandler}
    />
  );
}

const mapStateToProps = state => {
  const { apiServiceError } = state.app;
  return {
    apiServiceError,
  };
};

export default connect(mapStateToProps)(AppNotification);



// WEBPACK FOOTER //
// ./src/views/components/AppNotification/AppNotification.jsx